import { FileTypeEnum as e } from "../enums/file-type-enum.mjs";
//#region src/utils/file-input-accept-types.ts
var t = {
	image: ["image/*"],
	csv: [
		"text/csv",
		"application/vnd.ms-excel",
		"application/csv",
		".csv"
	]
}, n = (e, t) => t.some((t) => {
	if (t.includes("*")) {
		let n = t.replace("*", ".*");
		return RegExp(`^${n}$`).test(e);
	}
	return e.toLowerCase() === t.toLowerCase();
}), r = (e) => e.join(", "), i = {
	[e.Image]: ["image/*"],
	[e.ImageOther]: ["image/*"],
	[e.Video]: ["video/*"],
	[e.Audio]: ["audio/*"],
	[e.Font]: [
		"font/*",
		"application/font-woff",
		"application/x-font-ttf",
		"application/x-font-otf",
		".ttf",
		".otf",
		".woff",
		".woff2"
	],
	[e.Document]: [
		"application/pdf",
		"application/msword",
		"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
		"application/vnd.ms-excel",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		"application/vnd.ms-powerpoint",
		"application/vnd.openxmlformats-officedocument.presentationml.presentation",
		"text/plain",
		"text/csv",
		"application/csv",
		".pdf",
		".doc",
		".docx",
		".xls",
		".xlsx",
		".ppt",
		".pptx",
		".txt",
		".csv"
	]
}, a = (e) => [...new Set(e.flatMap((e) => i[e]))];
//#endregion
export { t as fileInputAcceptTypes, i as fileInputAcceptTypesByFileType, r as formatAcceptTypeForInput, a as getFileInputAcceptTypes, n as isAcceptTypeValid };
